import React from "react";
import moment from "moment-timezone";
import OrderInvoice from "../htmlToPdf/OrderInvoice";

const OrderItem = ({ item, timezone }) => {
    return (
        <>
            {item.invoice && Object.keys(item.invoice).length > 0 && (
                <OrderInvoice invoice={item.invoice} />
            )}
            <div>
                <div className="d-block d-md-flex justify-content-between align-items-end gap-3">
                    <div>
                        <h5 className="position-relative mb-1 text-capitalize">
                            {item?.user?.fName} {item?.user?.lName}
                        </h5>
                        <p className="fs-sm mb-2">
                            ORDER
                            #{item.orderNo} | {moment(item.orderTime).tz(timezone).format('ddd, MMM DD, YYYY, hh:mm A')}
                        </p>
                    </div>
                    <div className="text-md-end">
                        {item?.user?.phone && (
                            <h6 className="mb-2">Phone Number: {item.user.phone}</h6>
                        )}
                        <ul className="list-unstyled d-flex justify-content-md-end fs-sm mb-2 address-list">
                            {item?.user?.officeNo && <li>Office No: {item.user.officeNo}</li>}
                            {item?.user?.floor && <li>Floor: {item.user.floor}</li>}
                            {item.serviceType === "TakeAway" && (
                                <li>
                                    Delivery Time: {item?.deliveryTime
                                        ? moment(item.deliveryTime).tz(timezone).format('ddd, MMM DD, YYYY, hh:mm A')
                                        : "Not specified"}
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                <div className="d-sm-flex mb-3 gap-8">
                    {/* <div>
                        <p className="text-danger fs-sm fw-medium mb-0">
                            Order Status: {reverseEnum(OrderStatus)[item.orderStatus]}
                        </p>
                        <p className="text-danger fs-sm fw-medium mb-0">
                            Payment Status: {reverseEnum(PaymentStatus)[item.paymentStatus]}
                        </p>
                    </div> */}
                    {/* <div> */}
                    {/* <p className="text-danger fs-sm fw-medium mb-0">
                            Payment Type: {item.paymentType}
                        </p> */}
                    <p className="text-danger fs-sm fw-medium mb-0">
                        Service Type: {item.serviceType}
                    </p>
                    {/* </div> */}
                </div>
                <hr className="my-3" />
                <div className="d-md-flex justify-content-between fs-md mb-4">
                    <span className="mb-3 mb-md-0 fw-semibold">{item.items.map(i => `${i.name} (x${i.quantity})`).join(', ')}</span>
                    <div>
                        {item.discountAmount > 0 && (
                            <div>
                                <span className="text-nowrap text-end d-block">
                                    Total: &#8377;{item.totalPrice}
                                </span>
                                <span className="text-success text-nowrap text-end d-block">
                                    Discount: &#8377; -{item.discountAmount.toFixed(2)}
                                </span>
                            </div>
                        )}
                        <span className="fw-semibold text-nowrap text-end d-block">
                            To Pay: &#8377;{item.finalPrice}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderItem;
